(function () {
  'use strict';

  function setCollection(root, index) {
    root.querySelectorAll('[data-header-caster-collection-trigger]').forEach(function (trigger) {
      var active = String(trigger.dataset.collectionIndex) === String(index);
      trigger.classList.toggle('is-active', active);
    });

    root.querySelectorAll('[data-header-caster-product-panel]').forEach(function (panel) {
      var active = String(panel.dataset.collectionIndex) === String(index);
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  function setCategory(root, index) {
    root.querySelectorAll('[data-header-caster-category-trigger]').forEach(function (trigger) {
      var active = String(trigger.dataset.categoryIndex) === String(index);
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-header-caster-category-panel]').forEach(function (panel) {
      var active = String(panel.dataset.categoryIndex) === String(index);
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;

      if (active) {
        var firstCollection = panel.querySelector('[data-header-caster-collection-trigger]');
        if (firstCollection) setCollection(root, firstCollection.dataset.collectionIndex);
      }
    });
  }

  function boot() {
    if (window.matchMedia && !window.matchMedia('(min-width: 1024px)').matches) return;

    document.querySelectorAll('[data-header-caster-mega]').forEach(function (root) {
      var firstCategory = root.querySelector('[data-header-caster-category-trigger]');
      var firstCollection = root.querySelector('[data-header-caster-collection-trigger]');
      if (firstCategory) {
        setCategory(root, firstCategory.dataset.categoryIndex);
      } else if (firstCollection) {
        setCollection(root, firstCollection.dataset.collectionIndex);
      }
    });
  }

  document.addEventListener('mouseover', function (event) {
    var category = event.target.closest('[data-header-caster-category-trigger]');
    if (category) {
      var categoryRoot = category.closest('[data-header-caster-mega]');
      if (categoryRoot) setCategory(categoryRoot, category.dataset.categoryIndex);
      return;
    }

    var collection = event.target.closest('[data-header-caster-collection-trigger]');
    if (collection) {
      var collectionRoot = collection.closest('[data-header-caster-mega]');
      if (collectionRoot) setCollection(collectionRoot, collection.dataset.collectionIndex);
    }
  });

  document.addEventListener('focusin', function (event) {
    var category = event.target.closest('[data-header-caster-category-trigger]');
    if (category) {
      var categoryRoot = category.closest('[data-header-caster-mega]');
      if (categoryRoot) setCategory(categoryRoot, category.dataset.categoryIndex);
      return;
    }

    var collection = event.target.closest('[data-header-caster-collection-trigger]');
    if (collection) {
      var collectionRoot = collection.closest('[data-header-caster-mega]');
      if (collectionRoot) setCollection(collectionRoot, collection.dataset.collectionIndex);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 0);
  });
})();
